import { render, staticRenderFns } from "./FaqPage.vue?vue&type=template&id=501531d3&"
import script from "./FaqPage.vue?vue&type=script&lang=js&"
export * from "./FaqPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports